import * as React from 'react';
import {Link, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {User} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
import {AccountIcon} from 'shells/icon/svg/account-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ActivityIcon} from 'shells/icon/svg/activity-icon';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ImportIcon} from 'shells/icon/svg/icon-import';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TaskIcon} from 'shells/icon/svg/task-icon';
import {WebFormIcon} from 'shells/icon/svg/web-form-icon';

import {SidebarDrawer} from './sidebar-drawer';

import styles from './sidebar-create-new.module.css';

const CREATOR_HASH_PREFIX = '#/create/';

type OwnProps = {
    isActive: boolean;
    onClose: () => any;
    user: User | null | undefined;
};

type RoutedProps = OwnProps & ContextRouter;

type Props = RoutedProps;

export class SidebarCreateNewComponent extends React.PureComponent<Props> {
    render() {
        return (
            // Purposefully always rendering this div (and the EntityModal below)
            // as the EntityModal is the component listening for keyboard events
            // to pop the create forms.
            <div>
                {this.props.isActive ? (
                    <SidebarDrawer headerText='Add new'>
                        <div className={styles.container}>
                            {/* @ts-expect-error */}
                            <Link
                                to={{
                                    // GREP #/create/activities
                                    hash: `${CREATOR_HASH_PREFIX}activities`,
                                    search: this.props.location.search,
                                    state: {modal: true},
                                }}
                                replace={true}
                                onClick={this.handleEntityClick()}
                                className={styles['icon-container']}
                            >
                                <ActivityIcon
                                    size={32}
                                    color={colors.activity}
                                    className={styles.icon}
                                />
                                <div className={styles['content-container']}>
                                    <div className={styles.name}>Activity</div>
                                    <div className={styles.description}>
                                        Phone calls, meetings, and other interactions
                                    </div>
                                </div>
                            </Link>
                            {/* @ts-expect-error */}
                            <Link
                                to={{
                                    // GREP #/create/tasks
                                    hash: `${CREATOR_HASH_PREFIX}tasks`,
                                    search: this.props.location.search,
                                    state: {modal: true},
                                }}
                                replace={true}
                                onClick={this.handleEntityClick()}
                                className={styles['icon-container']}
                            >
                                <TaskIcon size={32} color={colors.task} className={styles.icon} />
                                <div className={styles['content-container']}>
                                    <div className={styles.name}>Task</div>
                                    <div className={styles.description}>
                                        Reminders and other things you don’t want to forget
                                    </div>
                                </div>
                            </Link>
                            {/* @ts-expect-error */}
                            <Link
                                to={{
                                    // GREP #/create/leads
                                    hash: `${CREATOR_HASH_PREFIX}leads`,
                                    search: this.props.location.search,
                                    state: {modal: true},
                                }}
                                replace={true}
                                onClick={this.handleEntityClick()}
                                className={styles['icon-container']}
                            >
                                <LeadIcon
                                    size={32}
                                    // @ts-expect-error
                                    color={colors.greenDk}
                                    className={styles.icon}
                                />
                                <div className={styles['content-container']}>
                                    <div className={styles.name}>Lead</div>
                                    <div className={styles.description}>
                                        A deal or opportunity to make a sale
                                    </div>
                                </div>
                            </Link>
                            {/* @ts-expect-error */}
                            <Link
                                id='create-new-person'
                                to={{
                                    // GREP #/create/contacts
                                    hash: `${CREATOR_HASH_PREFIX}contacts`,
                                    search: this.props.location.search,
                                    state: {modal: true},
                                }}
                                replace={true}
                                onClick={this.handleEntityClick()}
                                className={styles['icon-container']}
                            >
                                <ContactIcon
                                    size={32}
                                    // @ts-expect-error
                                    color={colors.navy}
                                    className={styles.icon}
                                />
                                <div className={styles['content-container']}>
                                    <div className={styles.name}>Person</div>
                                    <div className={styles.description}>
                                        Individuals you know or may do business with
                                    </div>
                                </div>
                            </Link>
                            {/* @ts-expect-error */}
                            <Link
                                to={{
                                    // GREP #/create/accounts
                                    hash: `${CREATOR_HASH_PREFIX}accounts`,
                                    search: this.props.location.search,
                                    state: {modal: true},
                                }}
                                replace={true}
                                onClick={this.handleEntityClick()}
                                className={styles['icon-container']}
                            >
                                <AccountIcon
                                    size={32}
                                    // @ts-expect-error
                                    color={colors.plum}
                                    className={styles.icon}
                                />
                                <div className={styles['content-container']}>
                                    <div className={styles.name}>Company</div>
                                    <div className={styles.description}>
                                        Organizations and groups you may do business with
                                    </div>
                                </div>
                            </Link>
                            {this.props.user && this.props.user.permissions.canImport ? (
                                // @ts-expect-error
                                <Link
                                    to='/setup/import'
                                    onClick={this.handleImportClick}
                                    className={styles['icon-container']}
                                >
                                    <ImportIcon
                                        size={32}
                                        color={colors.sidebarPrimary}
                                        className={styles.icon}
                                    />
                                    <div className={styles['content-container']}>
                                        <div className={styles.name}>Import</div>
                                        <div className={styles.description}>
                                            Transfer your existing data into Nutshell
                                        </div>
                                    </div>
                                </Link>
                            ) : undefined}
                            {this.props.user && this.props.user.permissions.canAccessMarketing ? (
                                // @ts-expect-error
                                <Link
                                    to={{
                                        // GREP #/create/forms
                                        hash: `${CREATOR_HASH_PREFIX}forms`,
                                        search: this.props.location.search,
                                        state: {modal: true},
                                    }}
                                    replace={true}
                                    onClick={this.handleEntityClick()}
                                    className={styles['icon-container']}
                                >
                                    <WebFormIcon
                                        size={32}
                                        // @ts-expect-error
                                        color={colors.sidebarPrimary}
                                        className={styles.icon}
                                    />
                                    <div className={styles['content-container']}>
                                        <div className={styles.name}>Form</div>
                                        <div className={styles.description}>
                                            Collect leads directly from your website
                                        </div>
                                    </div>
                                </Link>
                            ) : undefined}
                        </div>
                    </SidebarDrawer>
                ) : null}
            </div>
        );
    }
    handleImportClick = () => {
        this.props.onClose();
    };

    handleEntityClick = () => () => {
        this.props.onClose();
    };

    getPreviousHash = () => {
        return location.hash.includes(CREATOR_HASH_PREFIX) ? '' : location.hash;
    };
}

// @ts-expect-error
export const SidebarCreateNew = withRouter<OwnProps>(SidebarCreateNewComponent);
